import {
  formatExpirationDate,
  formatNumber,
  formatSecondsAsTime,
  parseMetricNumber,
} from "../../utils/eventFormatters";

export const METRICS_PAGE_LIMIT = 6;

export const getEventExpirationDate = (event) =>
  formatExpirationDate(
    event?.originalEvent?.expiration_date ||
      event?.originalEvent?.end_date ||
      event?.originalEvent?.endDate ||
      event?.endDate
  );

export const getMetricValue = (metric, fields) => {
  const field = fields.find(
    (fieldName) =>
      metric?.[fieldName] !== undefined &&
      metric?.[fieldName] !== null &&
      metric?.[fieldName] !== ""
  );

  return field ? metric[field] : "";
};

export const getMetricsPayload = (payload) => {
  const data = payload?.data || payload;

  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.metrics)) {
    return data.metrics;
  }

  if (Array.isArray(data?.items)) {
    return data.items;
  }

  return [];
};

export const getLastEvaluatedKey = (payload) => {
  const data = payload?.data || payload;

  return (
    data?.LastEvaluatedKey ||
    data?.lastEvaluatedKey ||
    data?.last_evaluated_key ||
    null
  );
};

export const normalizeMetricRow = (metric, index) => {
  const totalPlayers = getMetricValue(metric, [
    "total_players",
    "totalPlayers",
    "participants",
  ]);
  const statistic =
    getMetricValue(metric, [
      "game_name",
      "gameName",
      "game",
      "title",
      "name",
      "statistic",
    ]) || `Métrica ${index + 1}`;

  return {
    id: `${metric?.statistic || "metric"}-${metric?.sub || "ranking"}-${index}`,
    position: index + 1,
    game: statistic,
    participants: formatNumber(totalPlayers),
    totalPlays: formatNumber(
      getMetricValue(metric, ["total_count", "totalCount", "total_plays"])
    ),
    totalScore: formatNumber(
      getMetricValue(metric, ["total_score", "totalScore"])
    ),
    time: formatSecondsAsTime(
      getMetricValue(metric, ["total_time", "totalTime", "time"])
    ),
    xp: formatNumber(getMetricValue(metric, ["total_xp", "totalXp", "xp"])),
    rawTotalPlayers: parseMetricNumber(totalPlayers) || 0,
  };
};

export const normalizeGeneralMetricRow = (metrics, eventId) => ({
  id: `general-${eventId || "ranking"}`,
  position: "",
  game: "GERAL",
  participants: formatNumber(metrics?.participations),
  totalPlays: formatNumber(metrics?.total_play_count),
  totalScore: formatNumber(metrics?.total_play_score),
  time: formatSecondsAsTime(metrics?.total_play_time),
  xp: formatNumber(metrics?.total_xp),
  rawTotalPlayers: parseMetricNumber(metrics?.participations) || 0,
});
